<template>
  <div class="container inside-wrapper blog blog-details" id="news" data-aos="fade-up" data-aos-duration="1000">
    <div class="row">
      <div class="col-sm-12 loading" style="height: 700px" v-if="news_data === undefined && !news_error">
        <Loading />
      </div>
      <template v-if="news_data">
        <div
          style="height: 500px;display: flex;align-items: center;justify-content: center"
          v-if="news_data.data === 'error'">
          <h1 class="text-black">Not Found</h1>
        </div>
        <div class="col-sm-12" v-else>
          <div class="blog-read col-pad">
            <h2 class="text-red text-bold ">{{news_data.data[0].title}}</h2>
            <h5 class="text-bold text-dark">{{moment(news_data.data[0].created_on)}}</h5>
            <div class="img-box">
              <div class="img-box__img">
                <DefaultImage :id="news_data.data[0].image" :different="true" />
              </div>
            </div>
            <p class="description" v-html="news_data.data[0].text"></p>
          </div>
        </div>
      </template>

    </div>

    <div class="row contact-fourth back-red">
      <div class="col-sm-5 bottom-links text-left">
        <router-link to="/news">
          <h2 class="heading text-light"><i class="fa fa-long-arrow-left"> </i> News</h2>
        </router-link>
      </div>
      <div class="col-sm-2">
        <p></p>
      </div>
      <div class="col-sm-5 bottom-links text-right">
        <router-link to="/work">
          <h2 class="heading text-light">Works <i class="fa fa-long-arrow-right"> </i></h2>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import api from "../services/api";
  import useSWRV from "swrv";
  import Loading from "../components/Loading";
  import DefaultImage from "../components/default-image";
  import moment from "moment";

  export default {
    name: "NewsDetails",
    components: {DefaultImage, Loading},
    setup(props, {root}) {
      if (!root.$route.params.url) {
        root.$router.push({name: '/'});
      }
      const {
        data: news_data,
        error: news_error,
        isValidating: news_isValidating
      } = useSWRV(() => `items/news?status=published,draft&filter[slug]=${root.$route.params.url}`, api.fetcherForBlog);

      return {
        news_data,
        news_error,
        news_isValidating,
      };
    },
    mounted() {
      window.scrollTo(0, 0);
    },
    methods: {
      moment (date) {
        return moment(date).format('MMM DD, YYYY');
      },
    }
  }
</script>

<style>
  .blog-details h3 i {
    margin-right: 12px;
  }
  b, strong {
    font-weight: bold !important;
  }
  strong span {
    font-weight: bold !important;
  }
  .blog-details .description {
    white-space: pre-line;
  }
  .blog-details .img-box {
    margin: 20px 0;
  }
  .blog-details .img-box__img:before {
    padding-top: 50%;
  }
  #news {
    margin-top: 20px;
    margin-bottom: 100px;
  }
  #news .col-pad {
    padding: 40px 10px 0;
  }
  .text-black {
    color: #444;
  }
  @media (max-width: 991px) {
    .blog-details .img-box__img:before {
      padding-top: 80%;
    }
  }
</style>
